import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Link } from '@zapier/design-system';
import { skipLinkHref } from '../../constants';
import { interactiveReset } from '../../../utils/style-mixins/reset';
const Styles = labelStyles('SkipLink', {
    root: Object.assign(Object.assign({}, interactiveReset), { fontSize: 10, textTransform: 'uppercase', display: 'block', color: 'var(--zds-text-weaker, #574E4C)', opacity: 0, pointerEvents: 'none', textDecoration: 'none', '&:focus': {
            opacity: 1,
            outline: 'none',
        } }),
});
const SkipLink = ({ href = skipLinkHref, text = 'Skip to content' }) => {
    return (jsx(Link, { "aria-label": "Skip to main content", css: Styles.root, href: href }, text));
};
export default SkipLink;
//# sourceMappingURL=SkipLink.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
